export default{
    urls:[],
    isOk: false,
    error:null,
    errorMessage:'',

}